import React from "react";
import "../styles/Projects.css";
import FolderOpenRoundedIcon from "@material-ui/icons/FolderOpenRounded";
import FadeInSection from "./FadeInSection";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Carousel from "react-bootstrap/Carousel";
import ExternalLinks from "./ExternalLinks";

class Projects extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1"
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey
    });
  }
  render() {
    const spotlightProjects = {
      Mazemind: {
        title: "mazemind",
        desc:
          "A simulation-based AI game where a population of agents learn to reach a goal through natural selection and mutation.",
        techStack: "JAVASCRIPT",
        link: "https://github.com/hnav98/mazemind-ai",
        open:"https://hnav98.github.io/mazemind-ai",
        image: "assets/mazemind.png"
      },
      "Im Property Management": {
        title: "property management",
        desc:
          "A website I built for a client to professionally showcase their property management services with many features.",
        techStack: "HTML/CSS/JS",
        link: "https://github.com/hnav98/im-property-management",
        open: "https://impropertymanagement.com/",
        image: "assets/improperty.png"
      }
    };
    const projects = {
      "Guessing Game": {
        desc:
          "A simple terminal-based guessing game built in Python. The game randomly chooses a secret word, and the player has a limited number of guesses to figure it out.",
        techStack: "Python",
        link: "https://github.com/hnav98/guessing-game"
      },
      "Excel Comment Extractor": {
        desc:
          "This Python script extracts all cell comments from .xlsx Excel files in a specified folder. It collects the file name, sheet name, cell reference, and the comment content, and optionally prints or saves them as CSV.",
        techStack: "Python",
        link: "https://github.com/hnav98/excel-comment-extractor",
      },
      "Invoice Exporter": {
        desc:
          "A Python-based automation tool to download invoices from a Sonar instance using Selenium. It reads invoice IDs from a CSV file and automatically downloads each invoice as a PDF to a specified folder.",
        techStack: "Python, Selenium",
        link:
          "https://github.com/hnav98/invoice-exporter"
      }
    };

    return (
      <div id="projects">
        <div className="section-header ">
          <span className="section-title">/ projects</span>
        </div>
        <Carousel>
          {Object.keys(spotlightProjects).map((key, i) => (
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={spotlightProjects[key]["image"]}
                alt={key}
              />
              <div className="caption-bg">
                <Carousel.Caption>
                  <h3>{spotlightProjects[key]["title"]}</h3>
                  <p>
                    {spotlightProjects[key]["desc"]}
                    <p className="techStack">
                      {spotlightProjects[key]["techStack"]}
                    </p>
                  </p>
                  <ExternalLinks
                    githubLink={spotlightProjects[key]["link"]}
                    openLink={spotlightProjects[key]["open"]}
                  ></ExternalLinks>
                </Carousel.Caption>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
        <div className="project-container">
          <ul className="projects-grid">
            {Object.keys(projects).map((key, i) => (
              <FadeInSection delay={`${i + 1}00ms`}>
                <li className="projects-card">
                  <div className="card-header">
                    <div className="folder-icon">
                      <FolderOpenRoundedIcon
                        style={{ fontSize: 35 }}
                      ></FolderOpenRoundedIcon>
                    </div>
                    <ExternalLinks
                      githubLink={projects[key]["link"]}
                      openLink={projects[key]["open"]}
                    ></ExternalLinks>
                  </div>

                  <div className="card-title">{key}</div>
                  <div className="card-desc">{projects[key]["desc"]}</div>
                  <div className="card-tech">{projects[key]["techStack"]}</div>
                </li>
              </FadeInSection>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default Projects;
